import React from 'react';
import { CTAButton } from './CTAButton';
import { Zap } from 'lucide-react';
export function PersuasiveCTA() {
  return <section className="bg-gray-900 py-6 px-4 text-center" data-id="element-141">
      <div className="max-w-4xl mx-auto" data-id="element-142">
        <div className="flex flex-col items-center gap-3" data-id="element-143">
          <div className="inline-flex items-center justify-center w-14 h-14 bg-yellow-400 rounded-full mb-1 animate-pulse" data-id="element-144">
            <Zap className="w-8 h-8 text-black" fill="currentColor" data-id="element-145" />
          </div>

          <h2 className="text-2xl md:text-4xl font-bold text-white leading-tight" data-id="element-146">
            No dejes pasar esta oportunidad —{' '}
            <span className="text-yellow-400" data-id="element-147">Más de 500 docentes</span> ya
            transformaron su año escolar
          </h2>
        </div>
      </div>
    </section>;
}